<script>
import { usePartyStore } from "../stores/PartyStore";
export default {
  data() {
    return {
      partyStore: null,
    };
  },
  computed: {
    party() {
      return this.partyStore.party;
    },
  },
  async created() {
    this.partyStore = usePartyStore();
  },
};
</script>

<template>
  <div class="grid md:grid-cols-2 gap-2">
    <div>
      <span>
        {{ party.postalAddress.street1 }}<br />
        {{ party.postalAddress.zipStreet }} {{ party.postalAddress.cityStreet }}
        <br />
      </span>
    </div>
    <div>
      <span v-if="party.postalAddress.country === 'DE'">
        <img
          class="w-8 float-right ml-2"
          alt="DE"
          src="../assets/flagge-de.jpg"
        />
      </span>
      <span v-if="party.postalAddress.country === 'AT'">
        <img
          class="w-8 float-right ml-2"
          alt="AU"
          src="../assets/flagge-au.jpg"
        />
      </span>
      <span v-if="party.postalAddress.country === 'CH'">
        <img
          class="w-8 float-right ml-2"
          alt="CH"
          src="../assets/flagge-ch.jpg"
        />
      </span>
      <br />
      <p class="md:text-right" v-if="party.postalAddress.state">
        {{ $t("State." + party.postalAddress.state) }}<br />
      </p>
    </div>
  </div>
</template>